import { RegisteredRouter, useMatchRoute, UseMatchRouteOptions } from '@tanstack/react-router';

export function useIsRouteMatching<
  const TFrom extends string = string,
  const TTo extends string | undefined = undefined,
  const TMaskFrom extends string = TFrom,
  const TMaskTo extends string = '',
>(opts: UseMatchRouteOptions<RegisteredRouter, TFrom, TTo, TMaskFrom, TMaskTo>) {
  'use no memo'; // matchRoute does not get updated when using React Compiler
  const matchRoute = useMatchRoute();
  return !!matchRoute(opts);
}
